<template>
	<div>
		<CModal title="Modifier les informations du ticket" size="lg" :show.sync="showModal">
			<form ref="editForm" :action="ticket['@id']" method="post" axiosMethod="patch">
				<TicketInfoCard />
			</form>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Annuler</CButton>
				<CButton color="success" v-on:click="onSubmit($refs.editForm)">Modifier</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	import TicketInfoCard from './TicketInfoCard';
	export default {
		name: 'EditTicketModal',
		components: { TicketInfoCard },
		props: {
			ticket: Object,
		},
		data() {
			return {
				showModal: false,
			};
		},
		methods: {
			onSubmit: function (form) {
				this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.$toast.success('Informations modifiées avec succès !');
						this.showModal = false;
						this.$emit('update:ticket', res.data);
					} else {
						this.$toast.error(res.data['hydra:description']);
					}
				});
			},
		},
	};
</script>
